// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"AddCapteurComposante_TableauBootstrap__6yZmH","btn_stylo":"AddCapteurComposante_btn_stylo__6Ecml"};